import { render, staticRenderFns } from "./funesDatos.vue?vue&type=template&id=9b9d9708"
import script from "./funesDatos.vue?vue&type=script&lang=js"
export * from "./funesDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports